<template>
  <div class="legal-page">
    <div class="legal-container">
      <div class="legal-header">
        <h1>Política de Privacidade</h1>
        <p class="last-update">Última atualização: {{ currentDate }}</p>
      </div>

      <div class="legal-content">
        <section>
          <h2>1. Introdução</h2>
          <p>
            Esta Política de Privacidade descreve como coletamos, usamos, armazenamos e protegemos
            suas informações pessoais. Ao usar nosso site e serviços, você concorda com a coleta
            e uso de informações de acordo com esta política.
          </p>
          <p>
            <strong>Compromisso com a LGPD:</strong> Estamos comprometidos em proteger seus dados
            pessoais em conformidade com a Lei Geral de Proteção de Dados (LGPD - Lei nº 13.709/2018).
          </p>
        </section>

        <section>
          <h2>2. Informações que Coletamos</h2>
          <p>Coletamos diferentes tipos de informações para fornecer e melhorar nossos serviços:</p>

          <h3>2.1 Informações Fornecidas por Você</h3>
          <ul>
            <li>Nome completo</li>
            <li>Data de nascimento</li>
            <li>Endereço de e-mail</li>
            <li>Informações de pagamento (processadas por gateway seguro)</li>
            <li>Outras informações fornecidas voluntariamente durante o uso do serviço</li>
          </ul>

          <h3>2.2 Informações Coletadas Automaticamente</h3>
          <ul>
            <li>Endereço IP</li>
            <li>Tipo de navegador e dispositivo</li>
            <li>Páginas visitadas e tempo de navegação</li>
            <li>Cookies e tecnologias similares</li>
          </ul>
        </section>

        <section>
          <h2>3. Como Usamos suas Informações</h2>
          <p>Utilizamos suas informações pessoais para:</p>
          <ul>
            <li>Fornecer e personalizar nossos serviços de leitura numerológica</li>
            <li>Processar pagamentos e enviar confirmações</li>
            <li>Enviar comunicações sobre seu pedido e nossos serviços</li>
            <li>Melhorar nosso site e experiência do usuário</li>
            <li>Cumprir obrigações legais e regulatórias</li>
            <li>Prevenir fraudes e garantir a segurança</li>
          </ul>
        </section>

        <section>
          <h2>4. Compartilhamento de Informações</h2>
          <p>
            <strong>Não vendemos suas informações pessoais.</strong> Podemos compartilhar seus
            dados apenas nas seguintes situações:
          </p>
          <ul>
            <li>
              <strong>Processadores de Pagamento:</strong> Para processar transações financeiras
              de forma segura
            </li>
            <li>
              <strong>Provedores de Serviços:</strong> Empresas que nos auxiliam na operação do
              site (hospedagem, e-mail, análise)
            </li>
            <li>
              <strong>Obrigações Legais:</strong> Quando exigido por lei ou ordem judicial
            </li>
            <li>
              <strong>Proteção de Direitos:</strong> Para proteger nossos direitos, privacidade,
              segurança ou propriedade
            </li>
          </ul>
        </section>

        <section>
          <h2>5. Cookies e Tecnologias de Rastreamento</h2>
          <p>
            Utilizamos cookies e tecnologias similares para melhorar sua experiência. Você pode
            controlar o uso de cookies através das configurações do seu navegador.
          </p>
          <p>Tipos de cookies que utilizamos:</p>
          <ul>
            <li><strong>Cookies Essenciais:</strong> Necessários para o funcionamento do site</li>
            <li><strong>Cookies de Performance:</strong> Nos ajudam a entender como você usa o site</li>
            <li><strong>Cookies de Marketing:</strong> Utilizados para exibir anúncios relevantes</li>
          </ul>
        </section>

        <section>
          <h2>6. Seus Direitos (LGPD)</h2>
          <p>De acordo com a LGPD, você tem os seguintes direitos:</p>
          <ul>
            <li><strong>Acesso:</strong> Solicitar acesso aos seus dados pessoais</li>
            <li><strong>Correção:</strong> Solicitar correção de dados incompletos ou incorretos</li>
            <li><strong>Exclusão:</strong> Solicitar a exclusão de seus dados pessoais</li>
            <li><strong>Portabilidade:</strong> Solicitar a transferência de seus dados</li>
            <li><strong>Revogação:</strong> Revogar o consentimento a qualquer momento</li>
            <li><strong>Oposição:</strong> Se opor ao tratamento de seus dados</li>
          </ul>
          <p>
            Para exercer qualquer destes direitos, entre em contato conosco através dos
            canais disponíveis em nosso site.
          </p>
        </section>

        <section>
          <h2>7. Segurança dos Dados</h2>
          <p>
            Implementamos medidas de segurança técnicas e organizacionais apropriadas para
            proteger suas informações pessoais contra acesso não autorizado, alteração,
            divulgação ou destruição.
          </p>
          <p>No entanto, nenhum método de transmissão pela Internet é 100% seguro.</p>
        </section>

        <section>
          <h2>8. Retenção de Dados</h2>
          <p>
            Mantemos suas informações pessoais apenas pelo tempo necessário para cumprir as
            finalidades descritas nesta política, a menos que um período de retenção mais longo
            seja exigido por lei.
          </p>
        </section>

        <section>
          <h2>9. Privacidade de Menores</h2>
          <p>
            Nossos serviços não são destinados a menores de 18 anos. Não coletamos intencionalmente
            informações pessoais de menores. Se descobrirmos que coletamos dados de um menor,
            tomaremos medidas para excluir essas informações.
          </p>
        </section>

        <section>
          <h2>10. Plataformas de Terceiros</h2>
          <p>
            Este site pode conter links para sites de terceiros. Não somos responsáveis pelas
            práticas de privacidade desses sites. Recomendamos que você leia as políticas de
            privacidade de cada site que visitar.
          </p>
          <p>
            <strong>Isenção:</strong> Este site não faz parte do Facebook, Google ou qualquer
            outra plataforma de terceiros. NÃO somos endossados por essas plataformas.
            FACEBOOK é uma marca registrada da Meta Platforms, Inc.
          </p>
        </section>

        <section>
          <h2>11. Alterações nesta Política</h2>
          <p>
            Podemos atualizar esta Política de Privacidade periodicamente. Notificaremos você
            sobre alterações significativas publicando a nova política nesta página e atualizando
            a data de "Última atualização".
          </p>
        </section>

        <section>
          <h2>12. Contato</h2>
          <p>
            Se você tiver dúvidas sobre esta Política de Privacidade ou quiser exercer seus
            direitos de privacidade, entre em contato conosco através dos canais disponíveis
            em nosso site.
          </p>
        </section>
      </div>

      <div class="legal-footer">
        <router-link to="/" class="btn-back">← Voltar para o Início</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PoliticaDePrivacidade',
  computed: {
    currentDate() {
      const options = { year: 'numeric', month: 'long', day: 'numeric' };
      return new Date().toLocaleDateString('pt-BR', options);
    }
  }
}
</script>

<style scoped>
.legal-page {
  min-height: 100vh;
  background-color: purple;
  padding: 40px 20px;
}

.legal-container {
  max-width: 900px;
  margin: 0 auto;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 15px;
  padding: 40px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
}

.legal-header {
  text-align: center;
  margin-bottom: 40px;
  padding-bottom: 20px;
  border-bottom: 3px solid #ffdb60;
}

.legal-header h1 {
  font-size: 2.5rem;
  color: #1a1a2e;
  margin-bottom: 10px;
  font-weight: 700;
}

.last-update {
  color: #666;
  font-size: 0.9rem;
  font-style: italic;
}

.legal-content section {
  margin-bottom: 35px;
}

.legal-content h2 {
  font-size: 1.5rem;
  color: #1a1a2e;
  margin-bottom: 15px;
  font-weight: 600;
}

.legal-content h3 {
  font-size: 1.2rem;
  color: #333;
  margin: 20px 0 10px;
  font-weight: 600;
}

.legal-content p {
  line-height: 1.8;
  color: #333;
  margin-bottom: 15px;
  text-align: justify;
}

.legal-content ul {
  margin: 15px 0;
  padding-left: 25px;
}

.legal-content li {
  margin-bottom: 10px;
  line-height: 1.7;
  color: #333;
}

.legal-content strong {
  color: #1a1a2e;
  font-weight: 600;
}

.legal-footer {
  margin-top: 50px;
  text-align: center;
  padding-top: 30px;
  border-top: 2px solid #e0e0e0;
}

.btn-back {
  display: inline-block;
  padding: 12px 30px;
  background: #ffdb60;
  color: #1a1a2e;
  text-decoration: none;
  border-radius: 8px;
  font-weight: 600;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(255, 219, 96, 0.3);
}

.btn-back:hover {
  background: #ffd040;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(255, 219, 96, 0.4);
}

@media (max-width: 768px) {
  .legal-container {
    padding: 25px 20px;
  }

  .legal-header h1 {
    font-size: 1.8rem;
  }

  .legal-content h2 {
    font-size: 1.3rem;
  }

  .legal-content h3 {
    font-size: 1.1rem;
  }

  .legal-content p,
  .legal-content li {
    font-size: 0.95rem;
  }
}
</style>
